// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Button ────────────────────────────────────────────────── */
.scl--cms-components-notifBtn {
  position:        relative;
  width:           24px;
  height:          24px;
  display:         flex;
  align-items:     center;
  justify-content: center;
  background:      none;
  border:          none;
  padding:         0;
  cursor:          pointer;
  outline:         none;
  flex-shrink:     0;
}

/* ── Icon ──────────────────────────────────────────────────── */
.scl--cms-components-notifBtn-icon {
  position: absolute;
  left:     3px;
  top:      4px;
  width:    18px;
  height:   18px;
  /* SVG stroke transitions on hover via React state — no CSS needed */
}

/* ── Unread count badge ─────────────────────────────────────── */
.scl--cms-components-notifBtn-badge {
  position:        absolute;
  top:             0px;
  right:           0px;
  min-width:       14px;
  height:          14px;
  padding:         0 3px;
  border-radius:   999px;
  background: rgb(201, 45, 63);
  color:           #FFFFFF;
  font-family:     'Inter', sans-serif;
  font-weight:     600;
  font-size:       8px;
  line-height:     14px;
  text-align:      center;
  display:         flex;
  align-items:     center;
  justify-content: center;
  pointer-events:  none;
  box-sizing:      border-box;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/right-sidebar-fs-cp/rs-notification-op/notification-button/css/notificationButton.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,cAAc;EACd,cAAc;EACd,oEAAoE;AACtE;;AAEA,kEAAkE;AAClE;EACE,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;AAC7B","sourcesContent":["/* ── Button ────────────────────────────────────────────────── */\n.scl--cms-components-notifBtn {\n  position:        relative;\n  width:           24px;\n  height:          24px;\n  display:         flex;\n  align-items:     center;\n  justify-content: center;\n  background:      none;\n  border:          none;\n  padding:         0;\n  cursor:          pointer;\n  outline:         none;\n  flex-shrink:     0;\n}\n\n/* ── Icon ──────────────────────────────────────────────────── */\n.scl--cms-components-notifBtn-icon {\n  position: absolute;\n  left:     3px;\n  top:      4px;\n  width:    18px;\n  height:   18px;\n  /* SVG stroke transitions on hover via React state — no CSS needed */\n}\n\n/* ── Unread count badge ─────────────────────────────────────── */\n.scl--cms-components-notifBtn-badge {\n  position:        absolute;\n  top:             0px;\n  right:           0px;\n  min-width:       14px;\n  height:          14px;\n  padding:         0 3px;\n  border-radius:   999px;\n  background: rgb(201, 45, 63);\n  color:           #FFFFFF;\n  font-family:     'Inter', sans-serif;\n  font-weight:     600;\n  font-size:       8px;\n  line-height:     14px;\n  text-align:      center;\n  display:         flex;\n  align-items:     center;\n  justify-content: center;\n  pointer-events:  none;\n  box-sizing:      border-box;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
